import React from 'react';

export default function StepProgress({ steps }) {
  return (
    <div className="ps-stepper" aria-label="Sponsorship steps">
      {steps.map((step, index) => (
        <div key={step.label} className={`ps-step ${step.state}`}>
          <div className="ps-step-circle">{index + 1}</div>
          <div className="ps-step-label">{step.label}</div>
        </div>
      ))}
    </div>
  );
}
